var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.CustomFieldValue,{ref:"customFieldValue",attrs:{"field":_setup.fieldData,"editable":_vm.columnData.field.can_edit,"init-value":_setup.valueData,"from-table":true},on:{"valueChanged":_setup.valueChanged}})
}
var staticRenderFns = []

export { render, staticRenderFns }